import { getSettings } from "../services/settingsService";
import { getsettingsdata } from "../services/apiService";

let oauthClientConfig = {};

export function setOAuthClientConfig(config) {
  oauthClientConfig = { ...oauthClientConfig, ...config };
}

function generateState() {
  return Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
}

export async function getRedirectUri() {
  // Get base URL from settings or config, defaulting to the current origin
  const settingsBase = await getsettingsdata("oauth_redirect_base_url");
  const configBase = oauthClientConfig.oauth_redirect_base_url;
  const base = settingsBase || configBase || window.location.origin;
  
  let finalUrl;
  if (base.startsWith('http')) {
    // If it's already an absolute URL, use it as the base
    finalUrl = base;
  } else {
    // If it's a relative path, prepend the current origin
    const origin = window.location.origin;
    const path = base.startsWith('/') ? base : '/' + base;
    finalUrl = origin + path;
  }

  // Ensure it includes the /oauth-callback path
  if (!finalUrl.toLowerCase().includes('/oauth-callback')) {
    // Strip any trailing slashes and append the callback path
    finalUrl = finalUrl.replace(/\/+$/, '') + '/oauth-callback';
  }

  console.log("Resolved OAuth Redirect URI:", finalUrl);
  return finalUrl;
}

export async function getAuthorizeUrl(providerKey, { state } = {}) {
  const redirectUri = await getRedirectUri();
  console.log("getRedirectUri getAuthorizeUrl redirectUri :", redirectUri);
  const safeState = state || generateState();

  switch (providerKey) {
    case "facebook": {
      const clientId = await getsettingsdata("facebook_client_id");
      const base = "https://www.facebook.com/v17.0/dialog/oauth";
      const params = new URLSearchParams({
        client_id: String(clientId || ""),
        redirect_uri: redirectUri,
        response_type: "code",
        scope: "email,public_profile,pages_manage_posts,pages_read_engagement,pages_show_list",
        state: safeState,
      });
      return `${base}?${params.toString()}`;
    }
    case "google": {
      const clientId = oauthClientConfig.google_client_id || process.env.REACT_APP_GOOGLE_CLIENT_ID;
      const base = "https://accounts.google.com/o/oauth2/v2/auth";
      const params = new URLSearchParams({
        client_id: String(clientId || ""),
        redirect_uri: redirectUri,
        response_type: "code",
        access_type: "online",
        include_granted_scopes: "true",
        prompt: "consent",
        scope: "openid email profile",
        state: safeState,
      });
      return `${base}?${params.toString()}`;
    }
    case "linkedin": {
      const clientId = oauthClientConfig.linkedin_client_id || process.env.REACT_APP_LINKEDIN_CLIENT_ID;
      const base = "https://www.linkedin.com/oauth/v2/authorization";
      const params = new URLSearchParams({
        response_type: "code",
        client_id: String(clientId || ""),
        redirect_uri: redirectUri,
        state: safeState,
        scope: "r_liteprofile r_emailaddress",
      });
      return `${base}?${params.toString()}`;
    }
    case "twitter": {
      // For Twitter OAuth 2.0 Authorization Code with PKCE, typically requires server help
      // Here we leave as placeholder to be implemented server-side
      throw new Error("Twitter OAuth requires server orchestration. Configure server endpoint.");
    }
    case "instagram": {
      const clientId = oauthClientConfig.instagram_client_id || process.env.REACT_APP_INSTAGRAM_CLIENT_ID;
      const base = "https://api.instagram.com/oauth/authorize";
      const params = new URLSearchParams({
        client_id: String(clientId || ""),
        redirect_uri: redirectUri,
        response_type: "code",
        scope: "user_profile",
        state: safeState,
      });
      return `${base}?${params.toString()}`;
    }
    case "youtube": {
      // Use Google OAuth with YouTube scope
      const clientId = oauthClientConfig.google_client_id || process.env.REACT_APP_GOOGLE_CLIENT_ID;
      const base = "https://accounts.google.com/o/oauth2/v2/auth";
      const params = new URLSearchParams({
        client_id: String(clientId || ""),
        redirect_uri: redirectUri,
        response_type: "code",
        access_type: "online",
        include_granted_scopes: "true",
        prompt: "consent",
        scope: "openid email profile https://www.googleapis.com/auth/youtube.readonly",
        state: safeState,
      });
      return `${base}?${params.toString()}`;
    }
    default:
      throw new Error(`Unsupported provider: ${providerKey}`);
  }
}


